import React, {useContext, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {Button, TextField} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {getAllReportCreatedForData} from '../../../redux/reducers/ReportMaster';
import {getClientCodeDropDownData} from '../../../redux/reducers/TriggerGroup';
import LookupMaintenanceTable from './LookupMaintenanceTable';

function SearchLookupMaintenance({setValue, setRowData, TranslationTableAccess}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    lookupCode: '',
    description: '',
  };

  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
    dispatch(getAllReportCreatedForData());
  }, []);

  const onClear = () => {
    const data = {
      lookupCode: '',
      description: '',
    };
    setSearchData(data);
  };

  return (
    <div>
      <div className={` mb-0`}>
        <h2 className="search-title">Translation Search</h2>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              resetForm,
              touched,
            } = props;

            return (
              <div>
                <Form autoComplete="off">
                  <div className="form-row  standard-field-textfields new-standard-textfields">
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <TextField
                        margin="dense"
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        placeholder={`Enter Code`}
                        label="Code"
                        name="lookupCode"
                        value={values?.lookupCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.lookupCode}
                      />
                    </div>
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        name="description"
                        placeholder={`Enter Description`}
                        label="Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <div className=" d-flex justify-content-md-end justify-content-lg-start">
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn`}
                          onClick={() => {
                            setSubmit(true);
                            resetForm();
                            onClear();
                          }}
                        >
                          Reset
                        </Button>
                        <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <LookupMaintenanceTable
          setValue={setValue}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          setRowData={setRowData}
          TranslationTableAccess={TranslationTableAccess}
        />
      </div>
    </div>
  );
}

export default SearchLookupMaintenance;
